import { render, staticRenderFns } from "./data81.vue?vue&type=template&id=02705b7a&scoped=true&"
import script from "./data81.vue?vue&type=script&lang=js&"
export * from "./data81.vue?vue&type=script&lang=js&"
import style1 from "./data81.vue?vue&type=style&index=1&id=02705b7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02705b7a",
  null
  
)

export default component.exports